import React from 'react';
import ReportViewer from 'ReportViewer/layout';
import PropTypes from 'prop-types';
import ReportWrapper from 'ui/components/ReportWrapper';

class Output extends React.Component {
  static propTypes = {
    data: PropTypes.object.isRequired,
    intl: PropTypes.object.isRequired,
  };

  render() {
    return <ReportWrapper>
      <ReportViewer language={this.props.intl.locale} data={this.props.data.analysisObj} />
    </ReportWrapper>;
  }
}

export default Output;
